import dayjs from 'dayjs';
import cn from 'classnames';

import Location from './Location';

import {
  getDay,
  isDatesInOneMonth,
  getWeekday,
  getMonthName,
  isDatesInOneDay,
} from 'utils/dates';
import { EventType } from 'graphql/types';

import css from './PosterDate.module.scss';

interface IProps {
  dateStart?: string;
  dateEnd?: string;
  place?: string;
  event: EventType | null;
}

export default function PosterDate(props: IProps) {
  const { dateStart, dateEnd, place, event } = props;

  const startDate = dateStart || event?.startDate;
  const finishDate = dateEnd || event?.finishDate;
  const eventPlace =
    event?.alternativeAddress || place || event?.venue?.address?.city || '';

  const dayStart: string = getDay(startDate);
  const dayFinish: string = getDay(finishDate);

  const isTheSameMonth: boolean = !!isDatesInOneMonth(startDate, finishDate);
  const isDifferentDates: boolean = !isDatesInOneDay(startDate, finishDate);

  const weekday: string = isDifferentDates
    ? `${getWeekday(startDate, true)} - ${getWeekday(finishDate, true)}`
    : getWeekday(startDate);
  const monthName: string = getMonthName(startDate);

  if (!dayStart && !event) {
    return null;
  }

  return (
    <div
      className={cn(css.wrapper, !!event?.eventLinks?.length && css.noBorders)}
    >
      <div
        className={cn(
          css.date,
          !isDifferentDates
            ? css.withOneDay
            : isTheSameMonth
            ? css.withSingleMonth
            : css.withDifferentMonth,
          !!event?.eventLinks?.length && css.noBorders
        )}
      >
        {dayStart && (
          <>
            {isDifferentDates ? (
              <div className={css.days}>
                {isTheSameMonth
                  ? `${dayStart} - ${dayFinish}`
                  : `${dayjs(startDate).format('DD.MM')} - ${dayjs(
                      finishDate
                    ).format('DD.MM')}`}
              </div>
            ) : (
              <div className={css.days}>{dayStart}</div>
            )}
            <span className={css.weekday}>
              {`${isTheSameMonth ? monthName : ''}${
                isTheSameMonth && !event?.isHideWeekDays ? ', ' : ''
              }`}
              {/*скрываем дни недели, если флаг выставлен в true*/}
              {!event?.isHideWeekDays && weekday}
            </span>
          </>
        )}
      </div>
      {/* Отображаем локацию, только если не используются кастомные кнопки https://tracker.yandex.ru/DEVL-1902*/}
      {!event?.eventLinks?.length && (
        <Location place={eventPlace} isOffline={event?.isOffline ?? true} />
      )}
    </div>
  );
}
